import React, { useEffect, useState } from 'react';
import { Receipt, Loader2 } from 'lucide-react';
import { api } from '../../context/AuthContext';

const eur = (v) => Number(v || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
const datum = (d) => (d ? d.slice(0, 10).split('-').reverse().join('.') : '');

export const rechnungText = (r) => `Ihre Rechnung ${r.nummer} über ${eur(r.offen ?? r.betrag)}${r.faellig_am ? ` ist fällig am ${datum(r.faellig_am)}` : ' liegt für Sie bereit'}. `
  + `Sie können sie hier ansehen und bequem online bezahlen: ${window.location.origin}/portal/zahlungen`;

// Offene Rechnungen des Mandanten – ein Klick sendet Rechnung samt Bezahl-Link in den Chat
export const RechnungSenden = ({ mnr, onSend }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState('');
  useEffect(() => {
    if (!mnr) return;
    api.get('/kanzlei/rechnungen', { params: { mnr } })
      .then((r) => setItems((r.data.items || []).filter((x) => x.status === 'offen' && !x.lastschrift && !x.storniert)))
      .catch(() => setItems([]));
  }, [mnr]);
  if (!items.length) return null;
  const senden = async (r) => { setBusy(r.id); try { await onSend(rechnungText(r)); } finally { setBusy(''); } };
  return (
    <div className="flex flex-wrap items-center gap-1.5 mb-2" data-testid="rechnung-senden">
      <Receipt className="w-3.5 h-3.5 shrink-0 text-[#b8893d]" aria-label="Offene Rechnungen" />
      {items.slice(0, 4).map((r) => (
        <button key={r.id} type="button" disabled={!!busy} onClick={() => senden(r)} title="Rechnung mit Bezahl-Link sofort in den Chat senden" data-testid={`rechnung-senden-${r.id}`}
          className="shrink-0 inline-flex items-center gap-1.5 h-7 px-3 rounded-full border border-[#b8893d]/50 bg-[#fbf7f0] text-[11px] text-[#8f6a2b] hover:bg-[#b8893d] hover:text-white transition-colors disabled:opacity-50">
          {busy === r.id && <Loader2 className="w-3 h-3 animate-spin" />}Rechnung {r.nummer} · {eur(r.offen ?? r.betrag)} senden
        </button>
      ))}
      {items.length > 4 && <span className="text-[11px] text-[#7a8a99]" data-testid="rechnung-senden-weitere">+{items.length - 4} weitere unter Zahlungen</span>}
    </div>
  );
};

export default RechnungSenden;
